import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import { useUpcomingMeetings } from "@seabrookstudios/pitch2table";
import { DateTime } from "luxon";
import { SessionListItemNoConvention } from "../sessions/SessionListItem";
import CalendarMonth from "@mui/icons-material/CalendarMonth";

export const UpcomingMeetingsCard = () => {
  const meetings = useUpcomingMeetings();

  if (!meetings || meetings.length === 0) {
    return null;
  }

  return meetings.map((meeting) => {
    const relative = DateTime.fromMillis(meeting.date).toRelative();
    const title = meeting.type === "Pitching" ? "Pitch Meeting" : "Play Testing Session";

    return (
      <Card key={meeting.id}>
        <CardHeader title={title} subheader={`${relative}`} avatar={<CalendarMonth />} />
        <CardContent>
          <List>
            <SessionListItemNoConvention key={meeting.id} session={meeting} />
          </List>
        </CardContent>
      </Card>
    );
  });
};
